// Cache parent organisation lookups to avoid redundant API calls during route navigation.
// Each entry stores { parentId, timestamp } and expires after PARENT_ORG_CACHE_TTL_MS.
const parentOrgCache = new Map()
const PARENT_ORG_CACHE_TTL_MS = 5 * 60 * 1000 // 5 minutes

export function getParentOrg(orgId) {
  const cached = parentOrgCache.get(orgId)
  if (cached && Date.now() - cached.timestamp < PARENT_ORG_CACHE_TTL_MS) {
    return cached.parentId
  }
  return undefined
}

export function setParentOrg(orgId, parentId) {
  parentOrgCache.set(orgId, { parentId, timestamp: Date.now() })
}

export function clearParentOrgCache() {
  parentOrgCache.clear()
}
